"use strict";

exports.__esModule = true;
exports.ElementThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MissingWidgetThumbnail = require("./MissingWidgetThumbnail");
var _ElementRenderer = require("../ElementRenderer");
var _Utils = require("../../../Utils");
var _excluded = ["width", "height", "config", "components"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BackgroundSVG = _styledComponents["default"].svg.withConfig({
  displayName: "ElementThumbnail__BackgroundSVG",
  componentId: "sc-lkoa49-0"
})([""]);
var shouldUpdate = (0, _Utils.createShouldUpdate)("config", "width", "height");

/**
 * Renders a thumbnail for an element based on its configuration.
 */
var ElementThumbnail = exports.ElementThumbnail = /*#__PURE__*/function (_Component) {
  function ElementThumbnail() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementThumbnail, _Component);
  var _proto = ElementThumbnail.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return shouldUpdate(this.props, nextProps);
  };
  _proto.render = function render() {
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      config = _this$props.config,
      components = _this$props.components,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(BackgroundSVG, _extends({
      width: width,
      height: height,
      viewBox: (config.props.x || 0) + " " + (config.props.y || 0) + " " + config.props.width + " " + config.props.height
    }, extra), /*#__PURE__*/_react["default"].createElement(_ElementRenderer.ElementRenderer, {
      components: components,
      defaultComponent: _MissingWidgetThumbnail.MissingWidgetThumbnail,
      config: config
    }));
  };
  return ElementThumbnail;
}(_react.Component);